import React from "react";
import {
  Box,
  Paper,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

import StimulusManagerPage from "./StimulusManagerPage";
import {
  buildStimJsonFromBlocks,
  buildCmdFromRecipe,
  calcTotalSecondsFromCmd,
} from "./stimRecipes";

export default function StimulusManagerOnlyPage({ onBack, onWriteCmd }) {
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewCmd, setPreviewCmd] = React.useState("");
  const [previewSeconds, setPreviewSeconds] = React.useState(null);
  const [copyDone, setCopyDone] = React.useState(false);

  const CardBtn = ({ onClick, children }) => (
    <Card sx={{ width: "90%", backgroundColor: "#393939" }}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography
            sx={{
              fontSize: 20,
              fontFamily: "GmarketSansMedium",
              textAlign: "center",
            }}
            color="white"
          >
            {children}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );

  const handleStartCustom = async (customLoops) => {
    const blocksSpec = [];

    for (let loopIndex = 0; loopIndex < customLoops.length; loopIndex++) {
      const loop = customLoops[loopIndex];
      const repeatNum = Number(loop.repeat);

      if (!repeatNum || repeatNum <= 0) {
        alert(`Loop ${loopIndex + 1}: Repeat 값을 확인해주세요.`);
        return;
      }

      const stims = [];

      for (let stimIndex = 0; stimIndex < loop.stims.length; stimIndex++) {
        const s = loop.stims[stimIndex];
        const fields = ["width", "duration", "amp", "hold"];

        for (const f of fields) {
          if (s[f] === "" || s[f] == null) {
            alert(
              `Loop ${loopIndex + 1}, Stim ${stimIndex + 1}: ${f} 값이 비어있습니다.`
            );
            return;
          }
        }

        const width = Number(s.width);
        const duration = Number(s.duration);
        const amp = Number(s.amp);
        const hold = Number(s.hold);

        if (
          [width, duration, amp, hold].some(
            (v) => !Number.isFinite(v) || v < 0
          )
        ) {
          alert(
            `Loop ${loopIndex + 1}, Stim ${stimIndex + 1}: 숫자 값을 확인해주세요.`
          );
          return;
        }

        // StimCommand = [width(μs), duration(ms), amp(μA), hold(s)]
        stims.push([width, duration, amp, hold]);
      }

      blocksSpec.push({ repeat: repeatNum, stims });
    }

    const recipe = buildStimJsonFromBlocks(blocksSpec);
    const cmd = buildCmdFromRecipe(recipe);
    const seconds = calcTotalSecondsFromCmd(cmd);

    if (typeof onWriteCmd === "function") {
      try {
        await onWriteCmd(String(cmd));
      } catch (e) {
        console.error("[StimulusManagerOnlyPage] BLE write failed", e);
        alert("BLE 전송에 실패했습니다. 기기 연결 상태를 확인해주세요.");
        return;
      }
    } else {
      console.warn("[StimulusManagerOnlyPage] onWriteCmd가 없어 BLE 전송을 건너뜁니다.");
    }

    setPreviewCmd(String(cmd));
    setPreviewSeconds(seconds);
    setCopyDone(false);
    setPreviewOpen(true);
    alert("커스텀 자극 시작");

  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(previewCmd);
      setCopyDone(true);
    } catch (e) {
      alert("클립보드 복사에 실패했습니다. (브라우저 권한/HTTPS 확인)");
    }
  };

  return (
    <Paper
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#131313",
      }}
    >
      <Box style={{ color: "#CCCCCC" }}>
        <Box
          style={{
            padding: "0px 10px 30px 10px",
            borderRadius: 5,
            width: "90%",
            marginRight: "5%",
            marginLeft: "5%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              marginTop: 2,
              marginBottom: 2,
              flexWrap: "wrap",
            }}
          >
            <Typography
              sx={{ fontSize: 28, fontFamily: "GmarketSansMedium" }}
              color="white"
            >
              자극관리
            </Typography>

            <Button
              variant="outlined"
              onClick={onBack}
              sx={{ borderColor: "#CCCCCC", color: "#CCCCCC" }}
            >
              뒤로
            </Button>
          </Box>

          <StimulusManagerPage CardBtn={CardBtn} onStartCustom={handleStartCustom} />
        </Box>
      </Box>

      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>커스텀 자극 CMD 미리보기</DialogTitle>
        <DialogContent>
          <Typography sx={{ marginBottom: 1 }}>
            총 지속 시간: {previewSeconds != null ? `${previewSeconds}s` : "-"}
          </Typography>
          <TextField
            value={previewCmd}
            fullWidth
            multiline
            minRows={4}
            InputProps={{ readOnly: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={copyToClipboard}>{copyDone ? "복사됨" : "CMD 복사"}</Button>
          <Button onClick={() => setPreviewOpen(false)} autoFocus>
            닫기
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}